import type { ReactNode } from "react";
import NewReservationButton from "./NewReservationButton";

/**
 * Над списъка (широк екран): ‹ ден › по цялата останала ширина и
 * „+ Нова резервация" вдясно — 36px, на една линия с табовете на регионите
 * над платното. Докато формата за нова резервация е отворена, бутонът се
 * скрива (денят остава — сменя деня на схемата).
 */
const ReservationsSideControls = ({
  dayNavigator,
  onNewReservation,
}: {
  dayNavigator: ReactNode;
  // null — бутонът е скрит (формата е отворена).
  onNewReservation: (() => void) | null;
}) => (
  <div className="flex h-9 shrink-0 items-center gap-2">
    {dayNavigator}
    {onNewReservation && <NewReservationButton onClick={onNewReservation} />}
  </div>
);

export default ReservationsSideControls;
